export type AppLang = 'ru' | 'en';

type Dict = Record<string, string>;

const RU: Dict = {
  friend: 'Друг',
  loading: 'Загрузка...',
  connecting: 'Подключение...',
  almost_ready: 'Почти готово...',
  ready: 'Готово!',
  start: 'Начать',
  skip: 'Пропустить',
  open_vpn: 'Подключить',
  days: 'дней',
  home: 'Главная',
  vpn: 'VPN',
  profile: 'Профиль',
  support: 'Поддержка',
  copied: 'Скопировано!',
};

const EN: Dict = {
  friend: 'Friend',
  loading: 'Loading...',
  connecting: 'Connecting...',
  almost_ready: 'Almost ready...',
  ready: 'Ready!',
  start: 'Start',
  skip: 'Skip',
  open_vpn: 'Connect',
  days: 'days',
  home: 'Home',
  vpn: 'VPN',
  profile: 'Profile',
  support: 'Support',
  copied: 'Copied!',
};

export function normalizeLang(input?: string | null): AppLang {
  if (!input) return 'ru';
  const value = input.toLowerCase().trim();
  if (value === 'en' || value === 'english' || value.startsWith('en')) return 'en';
  return 'ru';
}

export function t(lang: AppLang, key: string): string {
  const dict = lang === 'en' ? EN : RU;
  return dict[key] ?? key;
}

